import {useContextStore} from '@/stores/context';

class RouterService {
  /**
   * Kiểm tra xem router hiện tại có hợp lệ không
   */
  isValidRouter(to) {
    const {Context} = useContextStore();
    let organizationPackCodeType = Context.OrganizationPackCodeType;
    let parentOrgPackCodeType = Context.ParentOrgPackCodeType;

    if (
      to.meta.orgPackCodeType &&
      Array.isArray(to.meta.orgPackCodeType) &&
      !to.meta.orgPackCodeType.includes(organizationPackCodeType)
    ) {
      return false;
    }

    if (
      to.meta.ParentOrgPackCodeType &&
      Array.isArray(to.meta.ParentOrgPackCodeType) &&
      !to.meta.ParentOrgPackCodeType.includes(parentOrgPackCodeType)
    ) {
      return false;
    }

    return true;
  }
}

export default new RouterService();
